import '../../../styles/label-perf-override.css';

import { Icon } from '~/components';
import { cn } from '~/lib/cn';
import type { Direction } from '~/modules/label-perf/types/label-perf';

export interface TrendProps {
  className?: string;
  children: string | number;
  direction: Direction;
  variant?: 'default' | 'table';
}

function Trend({ className, children, direction }: TrendProps) {
  const containerClasses = 'inline-block';

  const valueClasses = cn(
    'ml-xs text-body-md font-bold',
    direction === 'up' && 'text-success-default',
    direction === 'down' && 'text-error-default',
    direction === 'none' && 'text-subtle',
  );

  const iconClasses = cn(
    direction === 'up' && 'text-success-default',
    direction === 'down' && 'text-error-default',
    direction === 'none' && 'text-subtle',
  );

  return (
    <div className={cn(containerClasses, className)} data-testid="trend">
      <div className="flex items-center">
        {direction === 'up' && (
          <Icon
            type="caret-up"
            variant="solid"
            size="sm"
            className={iconClasses}
          />
        )}
        {direction === 'down' && (
          <Icon
            type="caret-down"
            variant="solid"
            size="sm"
            className={iconClasses}
          />
        )}
        <span data-testid="trend-child" className={valueClasses}>
          {children}
        </span>
      </div>
    </div>
  );
}

Trend.displayName = 'Trend';

export { Trend };
